<template>
	<slot :restore="handleRestore"></slot>
	<Alert
		:isOpen="showRestoreSuccessAlert"
		:title="t('restore_popup.success.title')"
		:text="t('restore_popup.success.body')"
		@onClose="onCloseRestoreSuccessAlert"
	/>
	<Alert
		:isOpen="showRestoreErrorAlert"
		:title="t('restore_popup.error.title')"
		:text="t('restore_popup.error.body')"
		@onClose="onCloseRestoreErrorAlert"
	/>
</template>

<script setup>
import { ref } from '@vue/reactivity'
import useApi from '@/composition/api.js'
import { useI18n } from 'vue-i18n'

import Alert from '@/components/Alert'

// eslint-disable-next-line no-undef
const emit = defineEmits(['success'])

const { t } = useI18n()

const { restore } = useApi()

const showRestoreSuccessAlert = ref(false)
const showRestoreErrorAlert = ref(false)

const onCloseRestoreSuccessAlert = () => {
	showRestoreErrorAlert.value = false
	emit('success')
}

const onCloseRestoreErrorAlert = () => {
	showRestoreErrorAlert.value = false
}

const handleRestore = () => {
	restore({
		closeOnSuccess: false,
		onFinish: () => {
			showRestoreSuccessAlert.value = true
		},
		onFail: () => {
			showRestoreErrorAlert.value = true
		}
	})
}
</script>
